<template>
  <vx-card :no-shadow="no_shadow" class="activity-log-style">
    <div v-if="activityId" class="flex justify-end mb-10">
      <vs-button @click="resetActivityLog">Reset</vs-button>
    </div>
    <vx-timeline :timelineData="timelineData" />
    <infinite-loading
      v-if="timelineMeta.has_next"
      @infinite="getMoreActivityLog"
      spinner="circles"
    >
      <div slot="no-results"></div>
    </infinite-loading>
  </vx-card>
</template>

<script>
import { getActivityList, getParticularActivity } from '@/api/activityLog'
import vxTimeline from './VxTimeline.vue'

export default {
  name: 'activityTimeline',
  props: ['lead_id', 'no_shadow', 'new_activity'],
  components: {
    vxTimeline
  },
  data () {
    return {
      leadId: this.lead_id,
      timelineData: [],
      timelineMeta: {
        total: null,
        limit: null,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: null
      },
      activityId: this.$route.params.activityId || null
    }
  },
  created () {
    if (!this.activityId) {
      this.getActivityLog()
    } else {
      this.getParticularActivityLog()
    }
  },
  watch: {
    lead_id (new_value) {
      this.leadId = new_value
      this.timelineData = []
      this.timelineMeta = {
        total: null,
        limit: null,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: null
      }

      this.getActivityLog()
    },
    new_activity (new_value) {
      this.timelineData.unshift({ ...new_value })
    }
  },
  methods: {
    resetActivityLog () {
      this.activityId = null
      this.getActivityLog()
    },
    async getParticularActivityLog () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.leadId,
        platform_module_id: 1,
        activity_id: this.activityId
      }

      try {
        const response = await getParticularActivity(payload)
        this.timelineData = [{ ...response.data.data.activity }]
      } catch (e) {
        console.log(e)
      }
    },
    async getActivityLog () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.leadId,
        platform_module_id: 1
      }

      try {
        const response = await getActivityList(payload)
        this.timelineData = response.data.data.activity
        this.timelineMeta = response.data.data.meta

      } catch (e) {
        console.log(e)
      }
    },
    async getMoreActivityLog ($state) {
      if (this.timelineMeta.has_next) {
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          entity_id: this.leadId,
          platform_module_id: 1
        }

        try {
          const response = await getActivityList(payload, this.timelineMeta.next_page_url)
          this.timelineData.push(...response.data.data.activity)
          this.timelineMeta = response.data.data.meta

          if (!this.timelineMeta.has_next) {
            $state.complete()
          } else {
            $state.loaded()
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        $state.complete()
      }
    }
  }
}
</script>

<style scoped>
.activity-log-style {
  max-height: 100%;
}
</style>
